import convertLayoutPositionToFlexStyles from '../utils/convertLayoutPositionToFlexStyles';
import type { DefaultSurfaceComponentWithProps } from 'owa-calendar-surface-core';
import { column } from '../SurfaceTemplates';
import type { ColumnProvider } from '../interfaces/ColumnProvider';
import { getColumnRangeHorizontalLayout } from '../logic/getColumnRangeHorizontalLayout';

/**
 * Creates the columns with content
 * @param columnProvider The column provider
 * @param columnContent The column content
 * @param columnBehaviors List of column behaviors
 * @returns collection JSX elements of columns
 */
export function createColumnsWithContent(
    columnProvider: ColumnProvider,
    columnContent: (columnModel: any, index: number) => JSX.Element[],
    getColumnComponent?: (columnModel: any, index: number) => DefaultSurfaceComponentWithProps
): JSX.Element[] {
    return columnProvider.columnModels.map((columnModel, index) => {
        let layout = getColumnRangeHorizontalLayout(index, index + 1, columnProvider);
        return column(
            'col_' + index,
            () => columnContent(columnModel, index),
            convertLayoutPositionToFlexStyles(layout),
            getColumnComponent(columnModel, index)
        );
    });
}
